<div class="custom-field" [class.no-character-limit]="!(field.CharacterLimit > 0)">
  @switch (field.ValidationType) {
    @case (customValidationType.Checkbox) {
      <div class="form-check" [class.checked]="innerValue">
        <input
          class="form-check-input"
          id="custom-field-{{ field.CustomFieldId }}"
          type="checkbox"
          [checked]="innerValue"
          [disabled]="isDisabled"
          [attr.aria-disabled]="isDisabled || null"
          [attr.aria-required]="field.IsRequired || null"
          [attr.aria-invalid]="isInvalid || null"
          [attr.aria-describedby]="isInvalid ? 'custom-field-error-' + field.CustomFieldId : null"
          [ngClass]="{ 'is-invalid': isInvalid }"
          (change)="onValueChange($event.target.checked)"
          (blur)="onBlur()"
        />
        <label class="rewards-terms-label ms-1" for="custom-field-{{ field.CustomFieldId }}">
          {{ field.DisplayName }}
        </label>
      </div>
    }
    @case (customValidationType.Date) {
      <div class="form-floating mb-1">
        <input
          type="text"
          class="custom-field-form form-control date-field"
          id="custom-field-{{ field.CustomFieldId }}"
          placeholder=""
          [ngModel]="date"
          (ngModelChange)="onDateChange($event)"
          ngbDatepicker
          #startDatePicker="ngbDatepicker"
          [disabled]="isDisabled"
          [attr.aria-disabled]="isDisabled || null"
          [attr.aria-required]="field.IsRequired || null"
          [attr.aria-invalid]="isInvalid || null"
          [attr.aria-describedby]="isInvalid ? 'custom-field-error-' + field.CustomFieldId : null"
          [attr.maxlength]="field.CharacterLimit > 0 ? field.CharacterLimit : null"
          [ngClass]="{ 'is-invalid': isInvalid }"
          [minDate]="minDate"
          readonly
          (click)="startDatePicker.open()"
        /><span
          class="material-icons date-field-icon"
          aria-hidden="true"
          (click)="$event.stopPropagation(); startDatePicker.toggle()"
          >calendar_month</span
        >
        <label class="display-name-custom-field" for="custom-field-{{ field.CustomFieldId }}">{{ field.DisplayName }}</label>
      </div>
    }
    @default {
      <div class="form-floating mb-1">
        <input
          type="text"
          class="custom-field-form form-control field"
          id="custom-field-{{ field.CustomFieldId }}"
          placeholder=""
          [value]="innerValue"
          [disabled]="isDisabled"
          [attr.aria-disabled]="isDisabled || null"
          [attr.aria-required]="field.IsRequired || null"
          [attr.aria-invalid]="isInvalid || null"
          [attr.aria-describedby]="isInvalid ? 'custom-field-error-' + field.CustomFieldId : null"
          [attr.maxlength]="field.CharacterLimit > 0 ? field.CharacterLimit : null"
          [ngClass]="{ 'is-invalid': isInvalid }"
          (input)="onValueChange($event.target.value)"
          (blur)="onBlur()"
        />
        <label class="display-name-custom-field" for="custom-field-{{ field.CustomFieldId }}">{{ field.DisplayName }}</label>
      </div>
    }
  }
  <!-- Errors + Character Limit -->
  <div class="d-flex justify-content-between align-items-start">
    <div>
      @if (control?.hasError('required') && control?.touched) {
        <div class="error-message alert-danger" role="alert" id="custom-field-error-{{ field.CustomFieldId }}">
          {{ 'custom.field.error.required' | translate }}
        </div>
      }
      @if (control?.hasError('maxlength') && control?.touched) {
        <div class="error-message alert-danger" role="alert" id="custom-field-error-{{ field.CustomFieldId }}">
          {{ 'custom.field.error.maxlength' | translate }}
          ({{ control?.errors?.['maxlength']?.actualLength }}/{{ control?.errors?.['maxlength']?.requiredLength }})
        </div>
      }
      @if (control?.hasError('pattern') && control?.touched) {
        <div class="error-message alert-danger" role="alert" id="custom-field-error-{{ field.CustomFieldId }}">
          {{ 'custom.field.error.validate.' + validationName | translate }}
        </div>
      }
    </div>
    @if (field.CharacterLimit > 0) {
      <div
        class="text-info font-size-12"
        aria-live="polite"
        [attr.aria-label]="(innerValue?.toString() ?? '').length + ' of ' + field.CharacterLimit + ' characters used'"
      >
        {{ innerValue?.toString()?.length ?? 0 }}/{{ field.CharacterLimit }}
      </div>
    }
  </div>
</div>
